import React from "react";
import "./styles.css";

const currentUser = "김코딩";

class Twittler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tweets: [
        {
          uuid: 1,
          writer: "김코딩",
          date: "2020-10-10",
          content: "안녕 리액트"
        },
        {
          uuid: 2,
          writer: "박해커",
          date: "2020-10-12",
          content: "좋아 코드스테이츠!"
        }
      ],
      newTweetContent: ""
    };

    this.onTextChange = this.onTextChange.bind(this);
    this.addNewTweet = this.addNewTweet.bind(this);
  }

  onTextChange(e) {
    this.setState({
      newTweetContent: e.target.value
    });
  }

  addNewTweet(e) {
    const newTweet = {
      uuid: this.state.tweets.length + 1,
      writer: currentUser,
      date: new Date().toISOString().substring(0, 10),
      content: this.state.newTweetContent
    };
    this.setState((prevState) => {
      return { tweets: [...prevState.tweets, newTweet] };
    });
  }

  render() {
    return (
      <div>
        <div>작성자: {currentUser}</div>
        <div id="writing-area">
          <textarea
            id="new-tweet-content"
            onChange={this.onTextChange}
          ></textarea>
          <button id="submit-new-tweet" onClick={this.addNewTweet}>
            새 글 쓰기
          </button>
        </div>
        <ul id="tweets">
          {this.state.tweets.map((t) => (
            <SingleTweet key={t.uuid} writer={t.writer} date={t.date}>
              {t.content}
            </SingleTweet>
          ))}
        </ul>
      </div>
    );
  }
}

Twittler.displayName = 'Twittler'

function SingleTweet({ writer, date, children }) {
  return (
    <li className="tweet">
      <div className="writer">{writer}</div>
      <div className="date">{date}</div>
      <div>{children}</div>
    </li>
  );
}

SingleTweet.displayName = 'SingleTweet'

export default Twittler;
